<bn-loading-overlay></bn-loading-overlay>

<div class="container" *ngIf="operacaoCarregada; else carregando">
  <form name="formOperacao" #formOperacao="ngForm" class="form" id="formOperacao">

    <div class="row">
      <div class="col">
        <h3>Operação <small *ngIf="!emInclusao" class="text-muted">(#ID: {{model?.id}})</small></h3>
        <h5 class="text-muted">{{ model?.detalhe?.nomeAgenteFinanceiro }}</h5>
      </div>

      <ng-template #meuId>
        <button class="btn btn-default " (click)="close()">Cancelar </button>
        <button class="btn btn-danger" (click)="salvar();dismiss()">Ok</button>
      </ng-template>

      <div class="col-auto">
        <button *ngIf="!apenasVisualizacao && !emInclusao && !modoEdicao" class="btn btn-primary" type="button"
          (click)="voltar()">Voltar</button>

        <button [disabled]="!podeEditar"
          *ngIf="!apenasVisualizacao && !visualizandoHistorico && !emInclusao && !modoEdicao && model?.codigoTipoOperacao == 'L' && podeLiberar()"
          class="btn btn-light" type="button" (click)="liberar()">Inserir liberação</button>

        <button [disabled]="!podeEditar"
          *ngIf="!apenasVisualizacao && !visualizandoHistorico && !emInclusao && !modoEdicao && model?.codigoTipoOperacao == 'L' && podeAmortizar()"
          class="btn btn-light" type="button" (click)="amortizar()">Amortizar</button>
        <button [disabled]="!podeEditar"
          *ngIf="!apenasVisualizacao && !visualizandoHistorico && !emInclusao && !modoEdicao && model?.codigoTipoOperacao == 'L' && podeRetificar()"
          class="btn btn-light" type="button" (click)="retificar()">Retificar</button>
        <button [disabled]="!podeEditar"
          *ngIf="!apenasVisualizacao && !emInclusao && !modoEdicao && model?.codigoTipoOperacao == 'L' && podeAditar()"
          class="btn btn-light" type="button" (click)="aditar()">Aditar</button>
        <button [disabled]="!podeCancelar"
          *ngIf="!apenasVisualizacao && !visualizandoHistorico && !emInclusao && !modoEdicao && (podeCancelarSolicitacaoOutorga() || podeCancelarGarantia())"
          class="btn btn-light" type="button" (click)="cancelarOperacao()">{{podeCancelarSolicitacaoOutorga() ?
          'Cancelar Solicitação' : 'Cancelar Garantia'}}</button>
        <button
          *ngIf="!apenasVisualizacao && !emInclusao && !modoEdicao && model?.codigoTipoOperacao == 'L' && model?.detalheCreditoLivre?.historicos?.length && !visualizandoHistorico"
          class="btn btn-primary" type="button" (click)="visualizarHistorico(true)">Histórico</button>
        <button
          *ngIf="!apenasVisualizacao && !emInclusao && !modoEdicao && model?.codigoTipoOperacao == 'L' && visualizandoHistorico"
          class="btn btn-primary" type="button" (click)="visualizarHistorico(false)">Fechar Histórico</button>
        <button [disabled]="!podeEditar" *ngIf="(modoEdicao || emInclusao) && formOperacao.pristine" type="button"
          class="btn btn-danger" (click)="cancela()">Cancelar</button>
        <button *ngIf="(modoEdicao && !emInclusao) && !formOperacao.pristine" type="button" class="btn btn-primary"
          bnConfirm tituloConfirm="Confirmação" msgConfirm="Descartar edições realizadas?"
          (onConfirm)="cancela()">Cancelar</button>
        <button *ngIf="(modoEdicao && emInclusao) && !formOperacao.pristine" type="button" class="btn btn-primary"
          bnConfirm tituloConfirm="Confirmação" msgConfirm="Descartar novo cadastro?"
          (onConfirm)="cancela()">Cancelar</button>
        <button [disabled]="!formOperacao.form.valid" *ngIf="(modoEdicao || emInclusao)" (click)="salvar()"
          class="btn btn-primary" type="button">Salvar</button>
        <button *ngIf="!(modoEdicao || emInclusao)"  [disabled]="!podeInformarLiquidacao" (click)="abrirModalTermosLiquidacao()"
          class="btn btn-success" type="button">Liquidar Operação</button>
        <button *ngIf="podeExportar && !(modoEdicao || emInclusao)" (click)="exportarJson()"
          class="btn btn-primary" type="button">Exportar JSON</button>
      </div>
    </div>

    <div class="row" *ngFor="let operacao of operacoes; let iope = index">

      <ul ngbNav #nav="ngbNav" [(activeId)]="activeTabId" class="col nav-tabs">
        <li [ngbNavItem]="'tabOperacao'">
          <a ngbNavLink>Operação garantida</a>
          <ng-template ngbNavContent>
            <aba-operacao-garantida
              [operacao]="operacao"
              [modoEdicao]="modoEdicao"
              [modoAditivo]="modoAditivo"
              [modoRetificacao]="modoRetificacao"
              [emInclusao]="emInclusao"
              [dadosDominio]="dadosDominio"
              [model]="model"
              [gestorConsulta]="GESTOR_CONSULTA"
              (opcaoEnvioEmit)="atribuirOpcaoEnvio($event)"
              (alteracaoClienteFinalAditivoEmit)="atribuirAlteracaoClienteFinalAditivo($event)">
            </aba-operacao-garantida>
          </ng-template>
        </li>

        <li *ngIf="operacao.detalhe?.historicos?.length > 0" [ngbNavItem]>
          <a ngbNavLink>Histórico</a>
          <ng-template ngbNavContent>
            <aba-historico [operacao]="operacao"></aba-historico>
          </ng-template>
        </li>

        <li [ngbNavItem]>
          <a ngbNavLink>Cliente</a>
          <ng-template ngbNavContent>
            <aba-cliente
              [operacao]="operacao"
              [modoAditivo]="modoAditivo"
              [modoEdicao]="modoEdicao"
              [modoRetificacao]="modoRetificacao"
              [dadosDominio]="dadosDominio"
              [emInclusao]="emInclusao"
              [model]="model"
              [modalidadeGarantia]="modalidadeGarantia"
              [alteracaoClienteFinalAditivo]="alteracaoClienteFinalAditivo">
            </aba-cliente>
          </ng-template>
        </li>

        <li *ngIf="operacao.codigoTipoOperacao == 'L' || (operacao.codigoTipoOperacao == 'R' && modalidadeAceita)" [ngbNavItem]>
          <a ngbNavLink>Outras Garantias</a>
          <ng-template ngbNavContent>
            <aba-outras-garantias
              [model]="model"
              [dadosDominio]="dadosDominio"
              [operacao]="operacao"
              [modoAditivo]="modoAditivo"
              [modoEdicao]="modoEdicao"
              [emInclusao]="emInclusao">
            </aba-outras-garantias>
          </ng-template>
        </li>

        <li *ngIf="operacao.codigoTipoOperacao == 'R'" [ngbNavItem]>
          <a ngbNavLink>Amortizações</a>
          <ng-template ngbNavContent>
            <aba-amortizacao-repasse [model]="model"></aba-amortizacao-repasse>
          </ng-template>
        </li>

        <li *ngIf="operacao.detalhe?.liberacoes?.length > 0" [ngbNavItem]>
          <a ngbNavLink>Liberações</a>
          <ng-template ngbNavContent>
            <aba-liberacoes
              [operacao]="operacao"
              [modoEdicao]="modoEdicao"
              [modoRetificacao]="modoRetificacao"
              [emInclusao]="emInclusao">
            </aba-liberacoes>
          </ng-template>
        </li>

        <li *ngIf="operacao.amortizacoes?.length > 0 || emInclusao || modoEdicao" [ngbNavItem]>
          <a ngbNavLink>Amortizações</a>
          <ng-template ngbNavContent>
            <aba-amortizacoes
              [model]="model"
              [operacao]="operacao"
              [modoEdicao]="modoEdicao"
              [emInclusao]="emInclusao"
              (aoCancelarAmortizacao)="cancelarAmortizacaoAntecipada($event)"
              (aoAdicionarAmortizacao)="adicionarAmortizacao()"
              (aoRemoverAmortizacao)="removerAmortizacao($event)"
              [refreshAbaAmortizacao]="refreshAbaAmortizacao">
            </aba-amortizacoes>
          </ng-template>
        </li>

        <li *ngIf="operacao.detalhe?.aditivos?.length > 0" [ngbNavItem]>
          <a ngbNavLink>Aditivos</a>
          <ng-template ngbNavContent>
            <aba-aditivos
              [operacao]="operacao"
              [dadosDominio]="dadosDominio"
              (aditivoCancelado)="aditivoCancelado($event)">
            </aba-aditivos>
          </ng-template>
        </li>

        <li *ngIf="podeAdicionarEcgTerceiro" [ngbNavItem]>
          <a ngbNavLink>Pagamento de ECG por terceiros</a>
          <ng-template ngbNavContent>
            <aba-pagamento-por-terceiros
              [model]="model"
              [dadosDominio]="dadosDominio"
              [operacao]="operacao"
              [modoAditivo]="modoAditivo"
              [modoEdicao]="modoEdicao"
              [emInclusao]="emInclusao">
            </aba-pagamento-por-terceiros>
          </ng-template>
        </li>

        <li *ngIf="podeVisualizarNota" [ngbNavItem]>
          <a ngbNavLink>Notas</a>
          <ng-template ngbNavContent>
            <aba-notas
              [model]="model"
              [podeCadastrarNota]="podeCadastrarNota">
            </aba-notas>
          </ng-template>
        </li>

        <li *ngIf="GESTOR_CONSULTA" [ngbNavItem]>
          <a ngbNavLink>SCR</a>
          <ng-template ngbNavContent>
            <aba-operacao-scr [model]="model"></aba-operacao-scr>
          </ng-template>
        </li>

        <li *ngIf="operacao.detalhe?.historicos?.length > 0" [ngbNavItem]>
          <a ngbNavLink>Sol. Honra</a>
          <ng-template ngbNavContent>
            <aba-solicitacoes-honra [model]="model"></aba-solicitacoes-honra>
          </ng-template>
        </li>
      </ul>

      <div [ngbNavOutlet]="nav"></div>


    </div>
    <div class="row" *ngIf="(modoEdicao || emInclusao)">
      <div class="mb-3 col-md-12"><label class="form-label"><b><span style="color: #b00020;">*</span> Campos obrigatórios</b></label></div>
    </div>
  </form>
</div>

<div class="container" *ngIf="ocorrencias?.length > 0">
  <div class="table-responsive">
    <table class="table-striped table-bordered">
      <thead>
        <tr>
          <th class="text-center">
            Erro(s) encontrado(s)
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let ocorrencia of ocorrencias">
          <td>
            {{ ocorrencia.siglaSeveridade == 'A' ? 'Aviso - ' : ''}}{{ocorrencia.mensagem }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<ng-template #carregando>
  <div class="loading-pesquisa">
    <i class="bn-loading"></i>
  </div>
</ng-template>
